import React  from "react";

import { AnalysisItem } from "../../forms/custom-cdr/threatAnalysis";
import { CDRInformationModel, CDRReviewInformation } from "../../forms/custom-cdr/schema";

import CDRInformationPDF from "./cdrInformationPDF";
import CDRThreatAnalysisPDF from "./cdrThreatAnalysis";
import CustomCDRCover from "./customCDRCover";
import ReviewApproval from "./reviewApprovalPDF";
import withPDF from "../../hoc/withPDF";

import * as models from '../../../utils/models';

interface Props {
    analysisItems: AnalysisItem[]
    cdrReportNumber: string;
    cdrInformation: CDRInformationModel | undefined;
    reviewInformation: CDRReviewInformation | undefined;
    projectDetails: models.Project;
}

const CDRReport: React.FC<Props> = ({ analysisItems, cdrReportNumber, cdrInformation, projectDetails, reviewInformation }) => {
    return ( 
        <React.Fragment>
            <CustomCDRCover cdrNumber={cdrReportNumber} projectDetails={projectDetails} />

            <CDRInformationPDF cdrReportNumber={cdrReportNumber} information={cdrInformation!} />

            <CDRThreatAnalysisPDF items={analysisItems} />

            <ReviewApproval information={cdrInformation!} reviewData={reviewInformation!} />
		</React.Fragment>
    );
};
 
export default withPDF(CDRReport);